/* projects/portal/src/app/pages/purchases/purchases.component.css */
.filter-field {
  width: 170px;
}
.view-toggle {
  height: 40px;
}
.view-toggle ::ng-deep .mat-button-toggle-label-content {
  line-height: 38px;
  font-size: 13px;
}
/*# sourceMappingURL=purchases.component.css.map */
